import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { Typography, Box, Tooltip } from '@mui/material';
import { SettingsContext } from '../context/SettingsContext';
import { TranslationContext } from '../context/TranslationContext';
import ColoredSwitch from './ColoredSwitch';

interface MenuItem {
  to: string;
  icon: React.ReactElement;
  label: string;
}

interface MenuGroup {
  group?: string;
  icon?: React.ReactElement;
  items: MenuItem[];
}

interface MenuProps extends React.HTMLAttributes<HTMLDivElement> {
  menuConfig: MenuGroup[];
  HeaderComponent: React.ComponentType;
}

function Menu({ menuConfig, HeaderComponent }: MenuProps) {
  const { darkMode, toggleDarkMode, collapsed, toggleCollapsed } = useContext(SettingsContext);
  const { t } = useContext(TranslationContext);

  const handleNavigationClick = () => {
    // setLoading(true);
  };

  const renderMenuItem = (to: string, icon: React.ReactElement, label: string) => (
    <li style={{ listStyleType: 'none', marginLeft: '8px', marginTop: collapsed ? '8px' : '4px', marginBottom: collapsed ? '10px' : '4px', marginRight: '0px' }}>
      {collapsed ? (
        <Tooltip title={t(label)} placement="right">
          <Link to={to} onClick={handleNavigationClick} style={{ display: 'flex', alignItems: 'center', translate: '8px -3px'}} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
            <Typography style={{ verticalAlign: 'middle', marginRight: '8px', marginBottom: '0px', marginLeft: '195px', borderRadius: '4px', transition: 'background-color 0.3s', translate: '-8px 3px' }}>{React.cloneElement(icon as React.ReactElement<any>, { } )}</Typography>
          </Link>
        </Tooltip>
      ) : (
        <Link to={to} onClick={handleNavigationClick}>
          <Typography>{React.cloneElement(icon as React.ReactElement<any>, { style: { verticalAlign: 'middle', marginRight: '8px', marginBottom: '3px' } })}{t(label)}</Typography>
        </Link>
      )}
    </li>
  );

  const renderDivider = () => {
    return <Box sx={{ height: "1px", background: "grey", width: collapsed ? "30px" : "100%", marginLeft: collapsed ? "200px" : 0, marginTop: 1, marginBottom: 1 }} />;
  }

  return (
    <Box className={`Menu ${collapsed ? 'collapsed' : ''}`} sx={{ transition: 'margin-left 0.3s', marginLeft: collapsed ? '-210px' : '0', width: '250px', position: 'fixed', top: 0, left: 0, bottom: 0, overflowY: 'auto', zIndex: 1200, boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)', overflow: 'hidden'}}>
      {!collapsed && <HeaderComponent />}
      <button onClick={toggleCollapsed} style={{ position: 'absolute', top: '3px', left: collapsed ? '224px' : '13px' }}>
        {collapsed ? '>' : '<'}
      </button>
      {!collapsed && (<Box sx={{ height: "1px", background: "grey", width: "100%", marginBottom: 1 }} />)}
      {collapsed && (<Box sx={{ marginBottom: 1 }} />)}

      {menuConfig.map((group, index) => (
        <Box key={index} className="MenuGroup">
          {!collapsed && group.group && (
            <Typography variant="h6" >
              {group.icon && React.cloneElement(group.icon as React.ReactElement<any>, { style: { verticalAlign: 'middle', marginRight: '8px', marginBottom: '5px' } })}
              {t(group.group)}
            </Typography>
          )}
          <ul>
            {group.items.map((item, idx) => renderMenuItem(item.to, item.icon, item.label))}
          </ul>
          {index < menuConfig.length - 1 && renderDivider()}
        </Box>
      ))}

      {!collapsed && (
        <Box sx={{ height: "1px", background: "grey", width: "100%", marginTop: 1, marginBottom: 0 }}>
          <ul>
            <li style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingTop: 0 }}>
              <Typography><Brightness7 style={{ verticalAlign: 'middle', marginRight: '8px', marginBottom: '3px' }} /></Typography>
              <ColoredSwitch checked={darkMode} onChange={toggleDarkMode} checkedColor='white' uncheckedColor='lightgrey' />
              <Typography><Brightness4 style={{ verticalAlign: 'middle', marginLeft: '8px', marginBottom: '3px' }} /></Typography>
            </li>
          </ul>
        </Box>
      )}
    </Box>
  );
}

export default Menu;
